const namespace = 'timezones';

export const GET_TIMEZONES = `${namespace}/GET_TIMEZONES`;
export const SET_TIMEZONE = `${namespace}/SET_TIMEZONE`;
